import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-menu bg--pink"
}
const _hoisted_2 = { class: "text--left menu-header" }
const _hoisted_3 = { class: "menu-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-menu" }, {
    default: _withCtx(() => [
      (_ctx.isMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/#header",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "title--large text--white" }, " SnapShare ", -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: link.url,
                  class: "menu-item"
                }, [
                  _createVNode(_component_router_link, {
                    to: link.url,
                    class: "menu-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(link.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}